import React, { Component } from 'react';
import { withRouter } from 'react-router';

import Overview from './apply-job-overview.component';
import Record from '../../record/record.component';
import Preview from '../../preview/preview.component';

// styles and icons
import { Row, Container, Col, Nav, Tab } from 'react-bootstrap';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DescriptionIcon from '@material-ui/icons/Description';
import MovieIcon from '@material-ui/icons/Movie';
import CheckIcon from '@material-ui/icons/Check';


class CreateJob extends Component {
    constructor(props) {
        super(props);
        this.state = [];
    }
    callBackFun = (data) => {
        if (data) {
            localStorage.setItem('job', JSON.stringify(data))
            this.setState({job: data })
        }
    }
    componentDidMount() {
        this.connect();
        // get data from props in case of edit job 
        if (this.props.location && this.props.location.state) {
            if(this.props.location.state.company){
                console.log(this.props.location.state);
                // save all data that comes from apply job to this.state.jobs
                // save bio that creates from server to this.state.bio
                localStorage.setItem('job', JSON.stringify(this.props.location.state));
                localStorage.setItem('bio', JSON.stringify(this.props.location.state.bio));

                this.setState({ ...this.state, job: this.props.location.state  , bio : this.props.location.state.bio });
            }
        }
        // get all data from localstorage 
        else if (localStorage.getItem('job')) {

            this.setState({ ...this.state, job: JSON.parse(localStorage.getItem('job')) });

            this.setState({ ...this.state, bio: JSON.parse(localStorage.getItem('bio')) });

        }
        // make all left links disabled 
        let list = document.getElementById("left-tabs-example");
        let nav_items = list.querySelectorAll(".nav-item a");
        window.setInterval(function () {
            for (let i = 0; i < nav_items.length; i++) {
                nav_items[i].setAttribute("aria-disabled", "true")
                nav_items[i].classList.add("disabled")
            }
        }, 100)
    }
    timeout = 250;
    // websocket 
    connect = () => {
        var ws = new WebSocket("wss://spreago.black-squares.com:6001/app/websocket?protocol=7&client=js&version=4.3.1&flash=false");
        let that = this; // cache the this
        var connectInterval;

        // websocket onopen event listener
        ws.onopen = () => {
            ws.send('{"event":"pusher:subscribe","data":{"channel":"bio"}}');
            ws.send('{"event":"pusher:subscribe","data":{"channel":"video"}}');

            that.timeout = 250; // reset timer to 250 on open of websocket connection 
            clearTimeout(connectInterval); // clear Interval on on open of websocket connection
        };
        // websocket onclose event listener
        ws.onclose = e => {
            console.log(
                `Socket is closed. Reconnect will be attempted in ${Math.min(
                    10000 / 1000,
                    (that.timeout + that.timeout) / 1000
                )} second.`,
                e.reason
            );

            that.timeout = that.timeout + that.timeout; //increment retry interval
            connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
        };
        // websocket message 
        let user_id = JSON.parse(localStorage.getItem('jwt')).user.id || localStorage.getItem('jwt').user.id
        ws.onmessage = evt => { 
            let newData = JSON.parse(evt.data);
            if(newData.event === "bioEdit"){
                let newBiography = JSON.parse(newData.data).bio;
                console.log(newBiography);
                console.log(parseInt(this.state.bio?.id));
                if(newBiography.user_id === user_id && newBiography.id === parseInt(this.state.bio?.id)){
                    localStorage.setItem('bio', JSON.stringify(newBiography))
                    that.setState({ ...that.state, bio:  JSON.parse(localStorage.getItem('bio')) });
                }
            }
            else if(newData.event === "bioProcessDone"){
                let bioProcessDone = JSON.parse(newData.data).bio;
                if(bioProcessDone.user_id === user_id){
                    if(bioProcessDone.id === this.state.bio?.id){
                        localStorage.setItem('bio', JSON.stringify(bioProcessDone))
                        that.setState({ ...that.state, bio:  bioProcessDone});  
                    }
                }
            }
        }
        // websocket onerror event listener
        ws.onerror = err => {
            console.error(
                "Socket encountered error: ",
                err.message,
                "Closing socket"
            );
            ws.close();
        };
    };
    check = () => {
        const { ws } = this.state;
        if (!ws || ws.readyState === WebSocket.CLOSED) this.connect(); //check if websocket instance is closed, if so call `connect` function.
    }
    render() {
        return (
            <div className="createBiography">
                <Container className="pt-4 container-fluid-responsive m-h-100">
                    <Tab.Container defaultActiveKey="first">
                        <Row className="m-0 pt-xs-4">
                            <Col sm={3}>
                                <Nav variant="pills" id="left-tabs-example" className="flex-column">
                                <Nav.Item>
                                            <Nav.Link eventKey="first" className="row m-0">
                                                    <Row className="m-0">
                                                        <Col xs={3} ><DescriptionIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1">Overview </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                    </Row>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">
                                                <Row className="m-0">
                                                        <Col xs={3} ><MovieIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1">Record </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                </Row>
                                                </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">
                                                <Row className="m-0">
                                                        <Col xs={2} ><CheckIcon/></Col>
                                                        <Col xs={7} className="p-0 pt-1"> Review & publish </Col>
                                                        <Col xs={3} className="text-right"><CheckCircleIcon/></Col>
                                                    </Row>
                                                </Nav.Link>
                                        </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={9} id="apply-job-content">
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Overview data={this.state.job}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second" >
                                        <Record data={this.state.bio? this.state.bio : ''} bioFor="applyJob"/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="third" >
                                        <Preview data={this.state.bio? this.state.bio : ''} applicationId={this.state.job && this.state.job.id} bioFor="applyJob"/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </div>
        )
    }
}

export default withRouter(CreateJob);